var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    attrs: {
      title: _vm.$tc("MultiPointRouting"),
      "pos-x": _vm.position.x,
      "pos-y": _vm.position.y,
      draggable: !_vm.loading
    },
    on: {
      close: _vm.closeCluster,
      changePosition: function($event) {
        return _vm.$emit("changeClusterWindowsPosition", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [
            _c("ClusterToolSVG", { staticClass: "floating-container-svg" })
          ]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c(
              "div",
              {
                staticClass: "floating-tool-content",
                staticStyle: { width: "250px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "cluster-objects-div" },
                  [
                    _c("cluster-selection-type-buttons", {
                      attrs: {
                        "selection-type": _vm.clusterTool.type
                          ? _vm.clusterTool.type
                          : "polygon",
                        creatable: _vm.clusterTool.creatable,
                        clusterTool: true
                      },
                      on: { setType: _vm.setClusterType }
                    }),
                    _vm._v(" "),
                    _vm.clusterToolWKT
                      ? _c("cluster-selected-objects", {
                          attrs: {
                            selectedObjects: _vm.clusterToolWKT,
                            selectionType: "polygon",
                            clusterTool: true
                          },
                          on: {
                            openObjectMenu: function($event) {
                              return _vm.openClusterObjectMenu(
                                $event.event,
                                $event.object
                              )
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("HighlightedBox", {
                      attrs: {
                        "bad-object": _vm.badObject,
                        "is-visible": _vm.showInstruction,
                        message: _vm.currentInstruction
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.clusterObjectMenu.open
                  ? _c("window-object-menu", {
                      directives: [
                        {
                          name: "on-clickaway",
                          rawName: "v-on-clickaway",
                          value: _vm.closeClusterObjectMenu,
                          expression: "closeClusterObjectMenu"
                        }
                      ],
                      attrs: {
                        event: _vm.clusterObjectMenu.event,
                        object: _vm.clusterObjectMenu.object,
                        actionFrom: _vm.selectedToolObjectLayer
                      },
                      on: {
                        updateGeoServer: _vm.updateGeoServer,
                        closeMenu: _vm.closeClusterObjectMenu,
                        openForm: _vm.openFormFromClusterObjectMenu,
                        openDetailForm: function($event) {
                          return _vm.openFormFromClusterObjectMenu("detail")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("home-window-button", {
                  attrs: {
                    label: _vm.$t("Create"),
                    disabled: !_vm.clusterToolButtonDisabled
                  },
                  on: { buttonClick: _vm.saveCluster }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.openClosureSelection
              ? _c("cluster-closure-selection", {
                  attrs: { "closure-options": _vm.polygonClosures },
                  on: {
                    submit: _vm.previewFromClosureSelection,
                    close: _vm.closeMultipleClosure
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b1d602b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b1d602b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/ClusterTool/ClusterToolWindow.vue
// module id = null
// module chunks = 